// import this after install `@mdi/font` package
import { aliases, fa } from './font-awesome';
import 'vuetify/styles';
import { createVuetify } from 'vuetify';

export default defineNuxtPlugin((app) => {
  const vuetify = createVuetify({
    icons: {
      defaultSet: 'fa',
      aliases,
      sets: {
        fa,
      },
    },
  })
  app.vueApp.use(vuetify)
});
